import React from 'react';

import CardLoader from 'component/Layout/Loader/Card';

import styles from '../List.module.scss';

interface ListLoaderProps {
    count?: number;
}

const ListLoader = ({ count = 25 }: ListLoaderProps) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div className={styles.Item} key={index}>
                    <CardLoader />
                </div>
            ))}
        </>
    );
};

export default ListLoader;
